module.exports = __webpack_public_path__ + "imgs/gg-p2x.fdb51b3d.webp";